import React from 'react'
import { Icon } from "@material-ui/core";
import GithubLogo from './GitHub-Mark-32px.png'

export const GithubIcon = () => (
    React.createElement(Icon, null
        , React.createElement('img', { src: GithubLogo, alt: "",  height: 25, width: 25,})
    )
)